export const EMPTY_SEARCH_LOCATION = {
  boundingBoxE: null,
  boundingBoxN: null,
  boundingBoxS: null,
  boundingBoxW: null,
  countryCode: null,
  geoType: null,
  latitude: null,
  longitude: null,
  stateCode: null,
  full: null,
  text: null,
};
